const IANA_REGION_PATTERN = /^[A-Za-z][A-Za-z0-9_+-]*(?:\/[A-Za-z0-9_+-]+)+$/

// Intl also accepts ambiguous abbreviations and case-only misspellings that carrot-clinic rejects.
export function isAvailabilityTimeZone(value: string | undefined): value is string {
  if (value === undefined || (value !== "UTC" && !IANA_REGION_PATTERN.test(value))) return false
  try {
    const canonical = new Intl.DateTimeFormat("en-US", { timeZone: value }).resolvedOptions().timeZone
    if (value !== canonical && value.toLowerCase() === canonical.toLowerCase()) return false
    return true
  } catch {
    return false
  }
}
